/* eslint-disable react/display-name */

import axios from 'axios'
import { saveAs } from 'file-saver'

const configLogin = () => {
  return { headers: { 'content-type': 'application/x-www-form-urlencoded' } }
}

const configFile = (language, token) => {
  return {
    headers: {
      'content-type': 'multipart/form-data',
      'Accept-Language': language,
      Authorization: 'Bearer ' + token
    }
  }
}

const config = (language, token) => {
  if (token) {
    return { headers: { 'Accept-Language': language, Authorization: 'Bearer ' + token } }
  } else {
    return { headers: { 'Accept-Language': language } }
  }
}

const getBaseUrl = (name) => {
  switch (name) {
    case 'auth':
      return process.env.REACT_APP_AUTH
    case 'apis':
      return process.env.REACT_APP_APIS
    case 'fake':
      return process.env.REACT_APP_FAKES
    default:
  }
}

export const apiPostLogin = (api, url, data, onSuccess, onError, tag) => {
  axios.post(`${getBaseUrl(api)}${url}`, data, configLogin()
  )
    .then((response) => onSuccess(response, data, tag))
    .catch((err) => {
      onError(err, data, tag)
    }
    )
}

export const apiPost = (api, url, data, onSuccess, onError, tag, lang, token, params) => {
  axios.post(`${getBaseUrl(api)}${url}`, data, config(lang, token)
  )
    .then((response) => onSuccess(response, tag, params, data))
    .catch((err) => {
      onError(err, data, tag)
    }
    )
}

export const apiPostFile = (api, url, data, onSuccess, onError, tag, lang, token, params) => {
  axios.post(`${getBaseUrl(api)}${url}`, data, configFile(lang, token)
  )
    .then((response) => onSuccess(response, tag, params, data))
    .catch((err) => {
      onError(err, data, tag)
    })
}

export const apiGet = (api, url, onSuccess, onError, tag, lang, token, params) => {
  axios.get(`${getBaseUrl(api)}${url}`, config(lang, token)
  )
    .then((response) => {
      onSuccess(response, tag, params)
    })
    .catch((err) => {
      onError(err, tag)
    })
}

export const apiGetFile = (api, url, onError, token, fileName) => {
  axios({
    method: 'get',
    url: `${getBaseUrl(api)}${url}`,
    responseType: 'blob',
    headers: {
      Authorization: 'Bearer ' + token
    }
  })
    .then(response => {
      const contentType = response.headers['content-type']
      var blob = new Blob([response.data], { type: contentType })
      saveAs(blob, fileName)
    })
    .catch((err) => {
      onError(err)
    })
}

export const apiDelete = (api, url, onSuccess, onError, tag, lang, token) => {
  axios.delete(`${getBaseUrl(api)}${url}`, config(lang, token))
    .then((response) => {
      onSuccess(response, tag)
    })
    .catch((err) => {
      onError(err, tag)
    })
}
